<template>
    <div class="index-vue">
        <!-- 侧边栏 -->
        <aside :class="asideClassName">
            <!-- logo -->
            <div class="logo-c">
                <div class="logo-div">
                    <img :src="logoPath" alt=""/>
                </div>
                <span v-show="isShowAsideTitle" style="margin-left: 5px;font-size: 16px;font-weight: bold">
                    {{ merchantInfo.logoName }}
                </span>
            </div>
            <!-- 菜单栏 -->
            <Menu class="menu" ref="asideMenu" theme="dark" width="100%" @on-select="selectMenuCallback"
                  accordion :open-names="openMenus" :active-name="currentPage" @on-open-change="menuChange">
                <!-- 动态菜单 -->
                <div v-for="(item, index) in menuItems" :key="index">
                    <Submenu :class="isShowAsideTitle? '' : 'shrink'" :name="index" v-if="!item.hidden">
                        <template slot="title">
                            <Icon :size="item.size" :type="item.type"/>
                            <span v-show="isShowAsideTitle">{{ item.text }}</span>
                        </template>
                        <div v-for="(subItem, i) in item.children" :key="index + i">
                            <Submenu :class="isShowAsideTitle? '' : 'shrink'" v-if="subItem.children"
                                     :name="index + '-' + i">
                                <template slot="title">
                                    <Icon :size="subItem.size" :type="subItem.type"/>
                                    <span v-show="isShowAsideTitle">{{ subItem.text }}</span>
                                </template>
                                <template v-for="(threeItem, k) in subItem.children">
                                    <a href="https://www.baidu.com" target="_blank" :key="index + i + k" v-if="threeItem.isExternal">
                                        <MenuItem :class="isShowAsideTitle? '' : 'shrink'" class="menu-level-3"
                                                  :name="'external-link-' + index + i + k">
                                            <template v-if="!threeItem.hidden">
                                                <a :href="threeItem.url" target="_blank" class="external">
                                                    <Icon :size="threeItem.size" :type="threeItem.type"/>
                                                    <span v-show="isShowAsideTitle">{{ threeItem.text }}</span>
                                                </a>
                                            </template>
                                        </MenuItem>
                                    </a>
                                    <MenuItem v-else :class="isShowAsideTitle? '' : 'shrink'" class="menu-level-3"
                                              :name="threeItem.name" :key="index + i + k">
                                        <template v-if="!threeItem.hidden">
                                            <Icon :size="threeItem.size" :type="threeItem.type"/>
                                            <span v-show="isShowAsideTitle">{{ threeItem.text }}</span>
                                        </template>
                                    </MenuItem>
                                </template>
                            </Submenu>
                            <template v-else-if="!subItem.hidden">
                                <a :href="subItem.url" v-if="subItem.isExternal" target="_blank" class="external">
                                    <MenuItem :class="isShowAsideTitle? '' : 'shrink'"
                                              :name="'external-link-' + index + '-' + i">
                                        <Icon :size="subItem.size" :type="subItem.type"/>
                                        <span v-show="isShowAsideTitle">{{ subItem.text }}</span>
                                    </MenuItem>
                                </a>
                                <MenuItem v-else :class="isShowAsideTitle? '' : 'shrink'" :name="subItem.name">
                                    <Icon :size="subItem.size" :type="subItem.type"/>
                                    <span v-show="isShowAsideTitle">{{ subItem.text }}</span>
                                </MenuItem>
                            </template>
                        </div>
                    </Submenu>
                </div>
            </Menu>
        </aside>

        <!-- 右侧部分 -->
        <section class="sec-right">
            <!-- 头部 -->
            <div class="top-c">
                <header>
                    <div class="h-left">
                        <div class="pointer" @click="isShrinkAside" title="收缩/展开">
                            <Icon type="ios-apps"/>
                        </div>
                        <!-- 面包屑功能 -->
                        <p class="crumbs">{{ crumbs }}</p>
                    </div>
                    <div class="h-right">
                        <div v-if="firstLogin" class="merchant-info" style="color: #ff0000">
                            首次登陆，请点击个人中心，修改密码
                        </div>
                        <div class="merchant-info">
                            {{ merchantInfo.name }}
                        </div>
                        <div class="merchant-info">
                            |
                        </div>
                        <div class="merchant-info">
                            {{ storeInfo.name }}
                        </div>
                        <!-- 下拉菜单 -->
                        <Dropdown trigger="click" @on-click="userOperate" @on-visible-change="showArrow">
                            <div class="pointer">
                                <span>{{ userName }}</span>
                                <Icon v-show="arrowDown" type="md-arrow-dropdown"/>
                                <Icon v-show="arrowUp" type="md-arrow-dropup"/>
                            </div>
                            <DropdownMenu slot="list">
                                <!-- name标识符 -->
                                <DropdownItem name="1">个人中心</DropdownItem>
                                <DropdownItem divided name="3">退出登陆</DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                </header>

                <!-- 标签栏 -->
                <div class="div-tags">
                    <ul class="ul-c">
                        <li v-for="(item, index) in tagsArry" :key="index" :class="{active: isActive(item.name)}" @click="activeTag(index)">
                            <a class="li-a">
                                {{ item.text }}
                            </a>
                            <Icon size="16" @click="closeTag(index)" type="md-close"/>
                        </li>
                    </ul>
                    <!-- 标签栏相关功能 -->
                    <!--                    <div class="div-icons">-->
                    <!--                        <div class="refresh-c" @click="reloadPage" title="刷新当前标签页">-->
                    <!--                            <Icon type="md-refresh"/>-->
                    <!--                        </div>-->
                    <!--                        <div class="tag-options" title="关闭标签">-->
                    <!--                            <Dropdown trigger="click" @on-click="closeTags">-->
                    <!--                                <Icon type="ios-options"/>-->
                    <!--                                <DropdownMenu slot="list">-->
                    <!--                                    <DropdownItem name="1">关闭其他标签</DropdownItem>-->
                    <!--                                    <DropdownItem name="2">关闭所有标签</DropdownItem>-->
                    <!--                                </DropdownMenu>-->
                    <!--                            </Dropdown>-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                </div>
            </div>
            <!-- 页面主体 -->
            <div class="main-content">
                <div class="view-c">
                    <keep-alive :include="keepAliveData">
                        <!-- 子页面 -->
                        <router-view v-if="isShowRouter"/>
                    </keep-alive>
                </div>
            </div>
        </section>
        <Modal v-model="modal" fullscreen :closable="false">
            <div style="padding: 0 100px">
                <Row style="margin-bottom: 20px">
                    <Col span="12" style="font-weight: bold;font-size: 20px">基本信息</Col>
                    <Col span="12" style="text-align: right">
                        <span v-if="isEdit">
                            <Button @click="isEdit = false">取消</Button>
                            <Button type="primary" style="margin-left: 10px" :loading="loading" @click="saveSelfInfo">保存</Button>
                        </span>
                        <Button v-else type="primary" @click="isEdit = true">编辑</Button>
                    </Col>
                </Row>
                <div v-if="firstLogin" style="color: #ff0000;margin-top: -10px;margin-bottom: 10px">首次登录，请先修改密码</div>
                <Row>
                    <Col span="4" class="container-title container-top">登录账号</Col>
                    <Col span="8" class="container-value container-top">
                        <span>{{ userInfo.account }}</span>
                        <a class="my-tip-title" @click="showModifyPwd">修改密码</a>
                    </Col>
                    <Col span="4" class="container-title container-top">姓名</Col>
                    <Col span="8" class="container-value container-top container-right">
                        <Input v-if="isEdit" v-model="userInfo.name"/>
                        <span v-else>{{ userInfo.name }}</span>
                    </Col>
                </Row>
                <Row>
                    <Col span="4" class="container-title">身份证号</Col>
                    <Col span="8" class="container-value">
                        <Input v-if="isEdit" v-model="userInfo.idCard"/>
                        <span v-else>{{ userInfo.idCard }}</span>
                    </Col>
                    <Col span="4" class="container-title">性别</Col>
                    <Col span="8" class="container-value container-right">
                        <Select v-if="isEdit" v-model="userInfo.gender">
                            <Option value="1" key="1">男</Option>
                            <Option value="2" key="2">女</Option>
                        </Select>
                        <span v-else>{{ getGender(userInfo.gender) }}</span>
                    </Col>
                </Row>
                <Row>
                    <Col span="4" class="container-title">年龄</Col>
                    <Col span="8" class="container-value">
                        <Input v-if="isEdit" v-model="userInfo.age"/>
                        <span v-else>{{ userInfo.age }}</span>
                    </Col>
                    <Col span="4" class="container-title">联系电话</Col>
                    <Col span="8" class="container-value container-right">
                        <Input v-if="isEdit" v-model="userInfo.phone"/>
                        <span v-else>{{ userInfo.phone }}</span>
                    </Col>
                </Row>
            </div>
            <div slot="footer" style="text-align: right">
                <Button style="margin-right: 10px" type="primary" @click="handleClose">关闭</Button>
            </div>
        </Modal>
        <Modal
            v-model="pwdModal"
            title="修改密码"
            footer-hide>
            <div>
                <Form :model="pwdForm" :label-width="80" ref="pwdForm" :rules="rulesPwd">
                    <FormItem label="原密码" prop="pwd">
                        <Input type="password" v-model="pwdForm.pwd" placeholder="请输入原密码"></Input>
                    </FormItem>
                    <FormItem label="新密码" prop="newPwd">
                        <Input type="password" v-model="pwdForm.newPwd" @input="checkPasswordStrength"
                               placeholder="请输入新密码"></Input>
                    </FormItem>
                    <div class="password-strength">
                        <span :class="['strength-bar', strengthClass]"></span>
                        <span class="strength-text">{{ strengthText }}</span>
                    </div>
                    <FormItem label="确认密码" prop="confirmPwd">
                        <Input type="password" v-model="pwdForm.confirmPwd" @input="checkPasswordStrength"
                               placeholder="请输入新密码"></Input>
                    </FormItem>
                </Form>
                <div slot="footer" style="text-align: right">
                    <Button style="margin-right: 10px" type="primary" :loading="loading" @click="handleConfirm">确定</Button>
                    <Button @click="handleCancelPassword">取消</Button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import {resetTokenAndClearUser} from '@/utils'
import {modifyMyPassword, modifyMySelf} from "@/api"

export default {
    name: 'index',
    data() {
        const validatePassword = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('密码不能为空'))
            }
            // 密码强度验证逻辑
            const strongRegex = new RegExp(
                '^'
                + '(?=.*[a-z])'
                + '(?=.*\\d)'
                + '(?=.*[A-Z!@#$%^&*])'
                + '.{8,}'
                + '$'
            )

            const mediumRegex = new RegExp(
                '^'
                + '(?=.*[a-zA-Z])'
                + '(?=.*\\d)'
                + '[a-zA-Z\\d]'
                + '{8,}'
                + '$'
            )

            if (strongRegex.test(value)) {
                this.strengthClass = 'strong'
                this.strengthText = '强'
            } else if (mediumRegex.test(value)) {
                this.strengthClass = 'medium'
                this.strengthText = '中'
            } else {
                this.strengthClass = 'weak'
                this.strengthText = '弱'
                return callback(new Error('密码至少8位，至少包括字母和数字'))
            }

            callback()
        }

        const validatePassword1 = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('确认密码不能为空'))
            }
            if (value !== this.pwdForm.newPwd) {
                return callback(new Error('两次输入密码不一致'))
            }
            callback()
        }

        return {
            // 用于储存页面路径
            paths: {},
            // 当前显示页面
            currentPage: '',
            openMenus: [], // 要打开的菜单名字 name属性
            menuCache: [], // 缓存已经打开的菜单
            hasNewMsg: true, // 是否有新消息
            isShowRouter: true,
            loading: false,
            msgNum: '10', // 新消息条数
            // 标签栏         标签标题     路由名称
            // 数据格式 {text: '首页', name: 'home'}
            // 用于缓存打开的路由 在标签栏上展示
            tagsArry: [],
            arrowUp: false, // 用户详情向上箭头
            arrowDown: true, // 用户详情向下箭头
            isShowAsideTitle: true, // 是否展示侧边栏内容
            main: null, // 页面主要内容区域
            asideClassName: 'aside-big', // 控制侧边栏宽度变化
            asideArrowIcons: [], // 缓存侧边栏箭头图标 收缩时用
            // 面包屑
            crumbs: '主页',
            userName: '',
            userImg: '',
            // 主页路由名称
            home: 'home',
            userInfo: {},
            pwdForm: {
                account: '',
                pwd: '',
                newPwd: '',
                confirmPwd: '',
            },
            logoPath: '',
            modal: false,
            pwdModal: false,
            isEdit: false,
            rulesPwd: {
                pwd: [
                    {required: true, message: '原密码不能为空', trigger: 'blur'},
                ],
                newPwd: [
                    {validator: validatePassword, trigger: 'blur', required: true},
                ],
                confirmPwd: [
                    {validator: validatePassword1, trigger: 'blur', required: true},
                ],
            },
            strengthClass: '',
            strengthText: '',
            firstLogin: false,
            merchantInfo: {},
            storeInfo: {},
        }
    },
    mounted() {
        // 第一个标签
        const name = this.$route.name
        this.currentPage = name
        this.tagsArry.push({
            text: this.nameToTitle[name],
            name,
            query: this.$route.query,
        })

        // 根据路由打开对应的菜单栏
        this.openMenus = this.getMenus(name)
        this.$nextTick(() => {
            this.$refs.asideMenu.updateOpened()
        })
        // 设置用户信息
        const userStr = sessionStorage.getItem('current-user')
        if (userStr != null) {
            this.userInfo = JSON.parse(userStr)
            this.userName = this.userInfo.name
            if (this.userInfo.firstLogin === 0) {
                this.firstLogin = true
                this.modal = true
            }
        }
        this.merchantInfo = JSON.parse(sessionStorage.getItem('merchantInfo'))
        let logoUri = this.merchantInfo.logoPath
        if (logoUri && logoUri !== '') {
            this.logoPath = process.env.VUE_APP_FILE_API + logoUri
        } else {
            this.logoPath = process.env.VUE_APP_FILE_API + "/logo.png"
        }
        this.storeInfo = JSON.parse(sessionStorage.getItem('storeInfo'))
        this.main = document.querySelector('.sec-right')
        this.asideArrowIcons = document.querySelectorAll('aside .ivu-icon-ios-arrow-down')

        // 监听窗口大小 自动收缩侧边栏
        this.monitorWindowSize()
    },
    watch: {
        $route(to) {
            const name = to.name
            this.currentPage = name
            if (name == 'error') {
                this.crumbs = '404'
                return
            }

            if (!this.keepAliveData.includes(name)) {
                // 如果标签超过8个 则将第一个标签删除
                if (this.tagsArry.length == 8) {
                    this.tagsArry.shift()
                }
                this.tagsArry.push({name, text: this.nameToTitle[name], query: to.query})
            }

            setTimeout(() => {
                this.crumbs = this.paths[name]
            }, 0)
        },
    },
    computed: {
        // 菜单栏
        menuItems() {
            return this.$store.state.menuItems
        },
        // 需要缓存的路由
        keepAliveData() {
            return this.tagsArry.map(item => item.name)
        },
        // 由于iView的导航菜单比较坑 只能设定一个name参数
        // 所以需要在这定义组件名称和标签栏标题的映射表 有多少个页面就有多少个映射条数
        nameToTitle() {
            const obj = {}
            this.menuItems.forEach(e => {
                this.processNameToTitle(obj, e)
            })

            return obj
        },
    },
    methods: {
        getMenus(name) {
            let menus
            const tagTitle = this.nameToTitle[name]
            for (let i = 0, l = this.menuItems.length; i < l; i++) {
                const item = this.menuItems[i]
                menus = []
                menus[0] = i
                if (item.text == tagTitle) {
                    return menus
                }

                if (item.children) {
                    for (let j = 0, ll = item.children.length; j < ll; j++) {
                        const child = item.children[j]
                        menus[1] = i + '-' + j
                        menus.length = 2
                        if (child.text == tagTitle) {
                            return menus
                        }

                        if (child.children) {
                            for (let k = 0, lll = child.children.length; k < lll; k++) {
                                const grandson = child.children[k]
                                menus[2] = i + '-' + j + '-' + k
                                if (grandson.text == tagTitle) {
                                    return menus
                                }
                            }
                        }
                    }
                }
            }
        },

        monitorWindowSize() {
            let w = document.documentElement.clientWidth || document.body.clientWidth
            if (w < 1300) {
                this.shrinkAside()
            }

            window.onresize = () => {
                // 可视窗口宽度太小 自动收缩侧边栏
                if (w < 1300 && this.isShowAsideTitle
                    && w > (document.documentElement.clientWidth || document.body.clientWidth)) {
                    this.shrinkAside()
                }

                w = document.documentElement.clientWidth || document.body.clientWidth
            }
        },

        // 判断当前标签页是否激活状态
        isActive(name) {
            return this.$route.name === name
        },
        // 跳转页面 路由名称和参数
        gotoPage(name, params, query) {
            this.currentPage = name
            this.crumbs = this.paths[name]
            this.$router.push({name, params, query})

            if (!this.keepAliveData.includes(name)) {
                // 如果标签超过8个 则将第一个标签删除
                if (this.tagsArry.length == 8) {
                    this.tagsArry.shift()
                }
                this.tagsArry.push({name, text: this.nameToTitle[name]})
            }
        },
        // 选择菜单回调函数
        selectMenuCallback(name) {
            if (name.includes('external-link')) return
            this.gotoPage(name)
            this.expandAside()
            setTimeout(() => {
                this.isShowAsideTitle = true
            }, 200)
        },
        // 用户操作
        userOperate(name) {
            switch (name) {
                case '1':
                    // 修改密码
                    this.modal = true
                    break
                case '3':
                    resetTokenAndClearUser()
                    this.$router.push({name: 'login'})
                    break
            }
        },
        handleClose() {
            this.modal = false
        },
        // 控制用户三角箭头显示状态
        showArrow(flag) {
            this.arrowUp = flag
            this.arrowDown = !flag
        },
        // 判断
        isShrinkAside() {
            if (this.isShowAsideTitle) {
                this.shrinkAside()
            } else {
                this.expandAside()
            }
        },
        // 收缩
        shrinkAside() {
            for (let i = 0, len = this.asideArrowIcons.length; i < len; i++) {
                this.asideArrowIcons[i].style.display = 'none'
            }

            this.isShowAsideTitle = false
            this.openMenus = []
            this.$nextTick(() => {
                if (this.$refs.asideMenu) {
                    this.$refs.asideMenu.updateOpened()
                }
            })

            setTimeout(() => {
                this.asideClassName = ''
                this.main.style.marginLeft = '90px'
            }, 0)
        },
        // 展开
        expandAside() {
            setTimeout(() => {
                this.isShowAsideTitle = true
                for (let i = 0, len = this.asideArrowIcons.length; i < len; i++) {
                    this.asideArrowIcons[i].style.display = 'block'
                }

                this.openMenus = this.menuCache
                if (this.$refs.asideMenu) {
                    this.$refs.asideMenu.updateOpened()
                }
            }, 200)
            this.asideClassName = 'aside-big'
            this.main.style.marginLeft = '220px'
        },
        // 刷新当前标签页
        reloadPage() {
            let name = this.$route.name
            let index = this.keepAliveData.indexOf(name)
            this.$nextTick(() => {
                if (this.tagsArry.length) {
                    this.isShowRouter = false
                    this.tagsArry.splice(index, 1)
                    this.$nextTick(() => {
                        this.tagsArry.splice(index, 0, {name, text: this.nameToTitle[name]})
                        this.gotoPage(name)
                        this.isShowRouter = true
                    })
                } else {
                    this.isShowRouter = false
                    this.$nextTick(() => {
                        this.tagsArry.push({name, text: this.nameToTitle[name]})
                        this.gotoPage(name)
                        this.isShowRouter = true
                    })
                }
            })
        },
        // 关闭单个标签
        closeTag(i) {
            let name = this.tagsArry[i].name
            this.tagsArry.splice(i, 1)
            window.event.stopPropagation()
            // 如果关闭的是当前标签 则激活前一个标签
            // 如果关闭的是第一个标签 则激活后一个标签
            if (this.tagsArry.length) {
                if (this.isActive(name)) {
                    if (i != 0) {
                        this.gotoPage(this.tagsArry[i - 1].name)
                    } else {
                        this.gotoPage(this.tagsArry[i].name)
                    }
                }
            } else if (name != this.home) {
                // 如果没有标签则跳往首页
                this.gotoPage(this.home)
            } else {
                this.reloadPage()
            }
        },
        // 根据路由名称关闭页面
        closeName(name) {
            for (let i = 0, len = this.tagsArry.length; i < len; i++) {
                if (this.tagsArry[i].name == name) {
                    this.closeTag(i)
                    break
                }
            }
        },
        // 批量关闭标签
        closeTags(flag) {
            if (flag == 1) {
                // 关闭其他标签
                this.tagsArry = []
                this.gotoPage(this.$route.name)
            } else {
                // 关闭所有标签
                this.tagsArry = []
                this.gotoPage(this.home)
                this.reloadPage()
            }
        },
        // 激活标签
        activeTag(i) {
            this.gotoPage(this.tagsArry[i].name, null, this.tagsArry[i].query)
        },
        // 消息通知
        info() {
            const self = this
            this.$Notice.info({
                title: `您有${this.msgNum}条消息`,
                render(h) {
                    return h('Button', {
                        attrs: {
                            type: 'info',
                            size: 'small',
                        },
                        on: {
                            click() {
                                // 点击查看跳转到消息页
                                self.gotoPage('msg')
                                self.hasNewMsg = false
                                self.msgNum = 0
                            },
                        },
                    }, [
                        '点击查看',
                    ])
                },
            })
        },
        // 菜单栏改变事件
        menuChange(data) {
            let index = 0
            if (data.length > 0) {
                index = data[0]
            }
            let menu = this.menuItems[index]
            if (!menu.children && menu.name && menu.name !== '') {
                this.gotoPage(menu.name)
            }
            this.menuCache = data
        },
        processNameToTitle(obj, data, text) {
            if (data.name) {
                obj[data.name] = data.text
                this.paths[data.name] = text ? `${text} / ${data.text}` : data.text
            }
            if (data.children) {
                data.children.forEach(e => {
                    this.processNameToTitle(obj, e, text ? `${text} / ${data.text}` : data.text)
                })
            }
        },
        getGender(gender) {
            if (gender == 1) {
                return '男'
            }
            if (gender == 2) {
                return '女'
            }
            return '未填写'
        },
        showModifyPwd() {
            this.pwdForm = {
                account: this.userInfo.account,
                pwd: '',
                newPwd: '',
                confirmPwd: '',
            }
            this.pwdModal = true
        },
        handleConfirm() {
            this.$refs.pwdForm.validate((valid) => {
                if (valid) {
                    modifyMyPassword(this.pwdForm).then(() => {
                        this.$Message.success({
                            background: true,
                            content: '修改成功，请重新登录',
                            onClose: () => {
                                resetTokenAndClearUser()
                                this.$router.push({name: 'login'})
                            },
                        })
                        this.pwdModal = false
                    }).finally(() => {
                        this.loading = false
                    })
                } else {
                    this.loading = false
                }
            })
        },
        handleCancelPassword() {
            this.pwdModal = false
        },
        saveSelfInfo() {
            modifyMySelf(this.userInfo).then(() => {
                this.isEdit = false
                this.$Message.success({
                    background: true,
                    content: '修改成功，请重新登录',
                    onClose: () => {
                        resetTokenAndClearUser()
                        this.$router.push({name: 'login'})
                    },
                })
            }).finally(() => {
                this.loading = false
            })
        },
        checkPasswordStrength() {
            this.$refs.pwdForm.validate()
        },
    },
}
</script>

<style scoped>
.index-vue {
    height: 100%;
    color: #666;
}

/* 侧边栏 */
aside {
    position: fixed;
    top: 0;
    left: 0;
    width: 90px;
    background: #20222A;
    height: 100%;
    transition: width .3s;
    overflow: auto;
}

.logo-c {
    display: flex;
    align-items: center;
    color: rgba(255, 255, 255, .8);
    font-size: 16px;
    margin: 20px 0;
    justify-content: left;
    padding-left: 10px;
}

.logo {
    width: 40px;
    margin-right: 10px;
}

.aside-big {
    width: 220px;
}

/* 主体页面 */
.sec-right {
    height: 100%;
    margin-left: 220px;
    transition: margin-left .3s;
    overflow: hidden;;
    background: #f3f7fd;
}

/* 主体页面头部 */
header {
    height: 36px;
    border-bottom: none;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 40px;
    padding-left: 10px;
    font-size: 14px;
}

header .ivu-icon {
    font-size: 24px;
}

.refresh-c {
    margin: 0 30px;
    cursor: pointer;
}

.h-right {
    display: flex;
    align-items: center;
    font-size: 13px;
}

.h-left {
    display: flex;
    align-items: center;
}

.user-img-c img {
    width: 100%;
}

.notice-c {
    cursor: pointer;
    position: relative;
}

.newMsg {
    position: absolute;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #FF5722;
    right: 0;
    top: 0;
}

.div-tags {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 4px 0 0 10px;
}

/* 标签栏 */
.ul-c {
    height: 32px;
    background: #fff;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    overflow: hidden;
    width: calc(100% - 10px);
}

.ul-c li {
    cursor: pointer;
    font-size: 12px;
    height: 100%;
    display: flex;
    padding: 0 20px;
    align-items: center;
    justify-content: center;
    border: 1px solid #e6e6e6;
}

a {
    color: #666;
    transition: none;
}

.li-a {
    max-width: 80px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.ul-c .ivu-icon {
    margin-left: 6px;
}

.active {
    background: #f3f7fd;
    border-left: 1px solid #e6e6e6 !important;
    border-bottom: none !important;
}

.active a {
    color: #409eff;
}

.active .ivu-icon {
    color: #409eff;
}

/* 主要内容区域 */
.main-content {
    height: calc(100% - 88px);
    overflow: hidden;
}

.view-c {
    position: relative;
    height: 100%;
    overflow: hidden;
}

.pointer {
    cursor: pointer;
}

.crumbs {
    margin-left: 10px;
    color: #97a8be;
    cursor: default;
}

.menu-level-3 .ivu-icon {
    font-size: 18px;
}

.shrink {
    text-align: center;
}

.external {
    color: rgba(255, 255, 255, .7);
}

.external > i {
    margin-right: 6px;
}

.merchant-info {
    margin-top: 4px;
    margin-right: 10px;
}

.container-title {
    background: #f3f3f3;
    border-left: 1px solid #dddddd;
    border-bottom: 1px solid #dddddd;
    padding: 10px 20px;
}

.container-value {
    border-left: 1px solid #dddddd;
    border-bottom: 1px solid #dddddd;
    padding: 10px 20px;
}

.container-top {
    border-top: 1px solid #dddddd;
}

.container-right {
    border-right: 1px solid #dddddd;
}

.my-tip-title {
    color: #2d8cf0;
    font-size: 13px;
    margin-left: 20px;
}

.password-strength {
    padding-left: 81px;
    margin-bottom: 5px;
}

.strength-bar {
    display: inline-block;
    height: 6px;
    width: 100px;
    margin-right: 10px;
    background: #eee;
}

.strength-bar.weak {
    background: #ff5500;
    width: 33px;
}

.strength-bar.medium {
    background: #ffaa00;
    width: 66px;
}

.strength-bar.strong {
    background: #19be6b;
    width: 100px;
}

.strength-text {
    font-size: 12px;
    color: #999;
}

.logo-div {
    height: 32px;
    width: 32px;
}

.logo-div > img {
    height: 100%;
    width: 100%;
    border-radius: 50%;
}
</style>
